/** @format */

import { ChangeDetectionStrategy, Component, inject, input, computed, effect } from '@angular/core';
import {
	selectShipMode,
	selectShipToMeButtonText,
	setFulfillmentButtonsShipMode
} from '@pdp/add-to-cart/data-access';
import {
	selectBundleShipToMeButtonText,
	selectEDDDisplayText,
	selectEDDDisplayVerbiage,
	selectKillswitch,
	selectResolvedSku
} from '@pdp/data-access/state';

import { ProductAnalyticsService } from '@shared/data-access/analytics';
import { Store } from '@ngrx/store';
import { PdpFulfillmentButtonComponent } from '../../ui/fulfillment-button/fulfillment-button.component';
import {
	homefieldIconFulfillmentShippingFilled,
	homefieldIconFulfillmentShippingOutlined,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-feature-ship-to-me-button',
	templateUrl: './ship-to-me-button.component.html',
	styleUrl: './ship-to-me-button.component.scss',
	imports: [PdpFulfillmentButtonComponent, HomefieldIconLibraryModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShipToMeButtonComponent {
	private readonly productAnalyticsService = inject(ProductAnalyticsService);
	private readonly store = inject(Store);
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	skuEDDEnabled = input<boolean>(false);
	isBundle = input<boolean>(false);

	// shipToMeButtonText$: Observable<FulfillmentButtonInterface>;
	shipToMeButtonText = computed(() => {
		const selector = this.isBundle()
			? selectBundleShipToMeButtonText
			: selectShipToMeButtonText;
		return this.store.selectSignal(selector)();
	});

	shipMode = this.store.selectSignal(selectShipMode);
	EDDDisplayText = this.store.selectSignal(selectEDDDisplayText);
	EDDDisplayVerbiage = this.store.selectSignal(selectEDDDisplayVerbiage);
	resolvedSku = this.store.selectSignal(selectResolvedSku);

	fulfillmentIconName = computed(() => {
		const buttonEnabled = !this.shipToMeButtonText().fulfillmentButtonDisabledClass;
		return this.shipMode() === 'shipToMe' && buttonEnabled
			? 'fulfillment-shipping-filled'
			: 'fulfillment-shipping-outlined';
	});

	pdpSkuEDDEventEnabled = this.store.selectSignal(selectKillswitch('pdpSkuEDDEventEnabled'));

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconFulfillmentShippingFilled,
			homefieldIconFulfillmentShippingOutlined
		]);
		effect(() => {
			if (this.pdpSkuEDDEventEnabled() && this.EDDDisplayText()) {
				this.productAnalyticsService.triggerAnalyticsEvent('skuEDD', {
					skuEDD: this.EDDDisplayText(),
					id: this.resolvedSku().partNumber
				});
			}
		});
	}

	setShipMode() {
		this.store.dispatch(setFulfillmentButtonsShipMode({ shipMode: 'shipToMe' }));
	}
}
